export const ArsConfig = function () {
    this.arsClientVersion = "1.2.1";
    this.MAX_ACCOUNTS = 2091;
    this.timeOutMills = 119000;
    return this;
};
